import React from 'react';
import { TherapistsList } from './therapists-list';

export const TeamMemberList = ({ ...props }) => {
  const render = () => <TherapistsList />;

  return render();
};
